module.exports = "/_next/static/images/AutomaticallyMeasure-2bd2e63e5f394c00eb71f68584c0ffe2.webp";